/* eslint-disable @typescript-eslint/no-explicit-any */
import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  storage: localStorage,
  key: "authentication",
});


export type AuthTypes = {
  isSecurity?: boolean,
  isLoggedIn: boolean,
  user?: any,
  data?: any,
  unit?: any,
}

export default atom<AuthTypes>({
  key: "authentication",
  default: {
    isLoggedIn: false,
    isSecurity: false,
    data: null,
    user: null,
    unit: null,
  },
  effects_UNSTABLE: [persistAtom],
});